if (!customElements.get("countdown-timer-bar")) {
  class a extends HTMLElement {
    constructor() {
      super(),
        (this.userDate = this.getAttribute("data-date")),
        (this.userTime = this.getAttribute("data-time")),
        (this.userOffset = this.getAttribute('data-tzo')),
        (this.compactCountdown = this.getAttribute('data-compact-countdown')),
        this.interval,
        this.setInterval(this.userDate, this.userTime);
        if (this.closest('.shopify-section-group-header-group')) {
          this.calcHeight();
        }
    }
    onInit(userDate, userTime) {
      (this.completedCountdown = this.getAttribute("data-completed")),
        (this.countdown = this.querySelector(".countdown-timer-bar__main")),
        (this.countdownHeading = this.querySelector(".countdown-timer-bar__end")),
        (this.daysEl = this.querySelector(".countdown-timer-bar__days")),
        (this.hoursEl = this.querySelector(".countdown-timer-bar__hours")),
        (this.minutesEl = this.querySelector(".countdown-timer-bar__minutes")),
        (this.secondsEl = this.querySelector(".countdown-timer-bar__seconds")),
        (this.section = this.closest(".section-countdown-timer-bar"));

      const userOffsetHours = parseInt(this.userOffset[0] + this.userOffset[1] + this.userOffset[2], 10) * 3600
      const userOffsetMinutes = parseInt(this.userOffset[0] + this.userOffset[3] + this.userOffset[4], 10) * 60
      const userOffset = (userOffsetHours + userOffsetMinutes) * 1000

      const now = new Date()
      const nowOffset = now.getTimezoneOffset() * (-60 * 1000)
      const offsetDiff = userOffset - nowOffset

      var t = new Date(userDate + "T" + userTime),
        t = t.getTime() - (now.getTime() + offsetDiff),
        t = t < 0 ? 0 : parseInt(t / 1000, 10),
        days = Math.floor(t / (24 * 3600)),
        hours = Math.floor((t % 86400) / 3600),
        s = Math.floor((t % 3600) / 60),
        i = Math.floor((t % 60));
        this.compactCountdown === 'true' && days >= 1 ? hours += days * 24 : null

      t <= 0 && "hide_section" === this.completedCountdown
        ? (clearInterval(this.interval), (this.section.style.display = "none"), (this.closest('.shopify-section-group-header-group') ? (document.documentElement.style.setProperty("--countdown-bar-height", "0px")) : null ))
        : t <= 0 && "show_text" === this.completedCountdown
        ? (this.countdown && (this.countdown.style.display = "none"),
          this.countdownHeading &&
            (this.countdownHeading.style.display = "flex"))
        : (1 === String(days).length
            ? this.daysEl && (this.daysEl.textContent = "0" + days)
            : this.daysEl && (this.daysEl.textContent = days),
          1 === String(hours).length
            ? this.hoursEl && (this.hoursEl.textContent = "0" + hours)
            : this.hoursEl && (this.hoursEl.textContent = hours),
          1 === String(s).length
            ? this.minutesEl && (this.minutesEl.textContent = "0" + s)
            : this.minutesEl && (this.minutesEl.textContent = s),
          1 === String(i).length
            ? this.secondsEl && (this.secondsEl.textContent = "0" + i)
            : this.secondsEl && (this.secondsEl.textContent = i));
    }
    setInterval(userDate, userTime) {
      clearInterval(this.interval),
        (this.interval = setInterval(this.onInit.bind(this, this.userDate, this.userTime), 1e3));
    }
    calcHeight() {
      new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.isIntersecting
            ? document.documentElement.style.setProperty(
                "--countdown-bar-height",
                t.boundingClientRect.height + "px"
              )
            : document.documentElement.style.setProperty("", "");
        });
      }).observe(this);
    }
  }
  customElements.define("countdown-timer-bar", a);
}